// extracted by css-extract-rspack-plugin
export default {"bottomActions":"hbiwFuAeb0BJAZKQ"};